import { READ_SAMPLES, readSamplesBusy, readSamplesError, readSamplesSuccess } from "./action";
import { call, put, takeEvery } from "redux-saga/effects";
import { readSamples } from "./api";

import { ActionTypes } from "../util";
import { logError } from "utils/utils";

const { REQUEST } = ActionTypes;

export function* readSamplesSaga() {
  try {
    yield put(readSamplesBusy(true));
    yield put(readSamplesError());
    const response = yield call(readSamples);
    yield put(readSamplesSuccess(response));
  } catch (error) {
    logError(error);
    yield put(readSamplesError(error.message));
  } finally {
    yield put(readSamplesBusy(false));
  }
}

export default function* samplesSaga() {
  yield takeEvery(READ_SAMPLES[REQUEST], readSamplesSaga);
}
